import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Edit from "@material-ui/icons/Edit";
import CalendarToday from "@material-ui/icons/CalendarToday";
import { dateformat } from "../../../../../utils/dateFormat";
import { AttendanceLocal } from "../../../../../@types/attendance-local";
import { useDetailsInfoStyles } from "./styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import AttendanceLocalMap from "./components/map";
import AttendanceLocalExpedient from "./components/expedient";
import { Link, useParams } from "react-router-dom";
import ExpedientFormUpdate from "./components/expedient-form/update";
import ExpedientFormCreate from "./components/expedient-form/create";
import { maskCep } from "../../../../../utils/maskCep";
import { usePermission } from "../../../../../hooks/usePermission";

type DetailsInfoProps = {
  attendanceLocal: AttendanceLocal;
};

export default function DetailsInfo({ attendanceLocal }: DetailsInfoProps) {
  const { slug } = useParams<{ slug: string }>();
  const { isAboveCoordenator } = usePermission();
  const { classes } = useDetailsInfoStyles();

  return (
    <Paper elevation={3}>
      <Box className={classes.head}>
        <Box className={classes.container}>
          <Box className={classes.header}>
            <Typography className={classes.title}>
              {attendanceLocal?.nome}
            </Typography>
            <Box
              className={`${classes.badge} ${attendanceLocal?.ativo ? classes.active : classes.inactive
                }`}
            >
              {attendanceLocal?.ativo ? "Ativo" : "Inativo"}
            </Box>
          </Box>
          <Box className={classes.infosContainer}>
            <Box className={classes.infoContainer}>
              <CalendarToday className={classes.icons} />
              <Typography className={classes.infoContainerText}>
                Adicionado: {dateformat(attendanceLocal?.created_at, true)}
              </Typography>
            </Box>
            <Box className={classes.infoContainer}>
              <CalendarToday className={classes.icons} />
              <Typography className={classes.infoContainerText}>
                Atualizado em: {dateformat(attendanceLocal?.updated_at, true)}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box className={classes.headerButtonGroup}>
          {!attendanceLocal?.horario_unidade ? (
            <ExpedientFormCreate slug={slug} />
          ) : (
            <ExpedientFormUpdate
              slug={slug}
              expedient={attendanceLocal.horario_unidade}
            />
          )}
          {isAboveCoordenator && (
            <Button
              component={Link}
              to={`/locais-de-atendimento/${slug}/editar`}
              startIcon={<Edit fontSize="small" />}
              className={classes.editButton}
            >
              Editar
            </Button>
          )}
        </Box>
      </Box>
      <Divider />
      <Box className={classes.content}>
        <Typography className={classes.subtitle}>
          Informações do local
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={6} className={classes.localInfoContainer}>
            <Typography className={classes.localInfoTitle}>
              Endereço Completo
            </Typography>
            <Typography className={classes.localInfoText}>
              {attendanceLocal?.endereco}, {attendanceLocal?.bairro},{" "}
              {attendanceLocal?.cidade?.cidade} -{" "}
              {attendanceLocal?.cep && maskCep(attendanceLocal.cep)}
            </Typography>
          </Grid>
          <Grid item xs={6} className={classes.localInfoContainer}>
            <Typography className={classes.localInfoTitle}>
              Órgão Responsável
            </Typography>
            <Typography className={classes.localInfoText}>
              {attendanceLocal?.orgao.sigla} - {attendanceLocal?.orgao.nome}
            </Typography>
          </Grid>
          <Grid item xs={6} className={classes.localInfoContainer}>
            <Typography className={classes.localInfoTitle}>
              Horário de Funcionamento
            </Typography>
            <AttendanceLocalExpedient
              expedient={attendanceLocal?.horario_unidade}
            />
          </Grid>
          <Grid item xs={6} className={classes.localInfoContainer}>
            <Typography className={classes.localInfoTitle}>
              Mapa (source)
            </Typography>
            {attendanceLocal?.source ? (
              <AttendanceLocalMap source={attendanceLocal?.source} />
            ) : (
              <Typography className={classes.localInfoText}>
                Nenhum cadastrado.
              </Typography>
            )}
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
